import { DestroyRef, inject, Injectable } from "@angular/core";
import { interval, Observable, switchMap } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { map, shareReplay, startWith } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { LorenDevice } from "../loren-devices/interfaces/loren-device.interface";

@Injectable({ providedIn: "root" })
export class DeviceService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly http = inject(HttpClient);
  private readonly interval$ = interval(1000 * 60 * 10).pipe(startWith(0));
  private readonly devices$ = this.interval$.pipe(
    takeUntilDestroyed(this.destroyRef),
    switchMap(() => this.http.get<{ items: LorenDevice[] }>(`${environment.apiServerUrl}/devices`)),
    map(x => x.items),
    map(x => Object.freeze(x)), // Ensure values are immutable
    shareReplay({
      refCount: true,
      bufferSize: 1,
    })
  );

  get all() {
    return this.devices$;
  }

  get(id: number): Observable<LorenDevice | undefined> {
    return this.devices$.pipe(
      map(devices => devices.find(x => x.id == id)),
    )
  }
}